import { render, staticRenderFns } from "./AthleteSelfAssessmentFormStep.vue?vue&type=template&id=24cae1af&scoped=true&"
import script from "./AthleteSelfAssessmentFormStep.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentFormStep.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentFormStep.vue?vue&type=style&index=0&id=24cae1af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cae1af",
  null
  
)

export default component.exports